
<button
  (click)="signIn()"
  class="btn btn-dark d-flex align-items-center justify-content-center px-3 w-100"
  type="reset"
  style="padding: 0px; height: 40px; text-transform: none;"
>
  <img src="/assets/images/Apple_logo.png" height="20" class="me-2">
  {{'Core.SignInApple' | translate:locale.language}}
</button>


<div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>